export default __webpack_public_path__ + "static/media/plane.9eafdb5a.svg";